<template>
	<div class="aptamer-favorite-container">
		<div class="item-list">
			<div class="item-container" v-for="(item, i) in records" :key="i">
				<div class="item">
					<!-- <div class="figure">
						<img :src="item.secondaryStructureFigure" />
					</div> -->
					<div class="location">
						<a :href="`/paper/${item.articleID}`" class="entry entry-title">
							{{ item.articleTitle }}
						</a>
						<div class="entry">
							<div>
								作者：<span style="color: #3463ea;">{{ item.author }}</span>
							</div>
						</div>
						<div class="entry">
							<div>
								杂志名称：<span style="color: #3463ea;">{{
									item.journal || 0
								}}</span>
							</div>
							<div style="margin-left: 16px;">
								期刊号：<span style="color: #3463ea;">{{ item.issn }}</span>
							</div>
						</div>
						<div class="entry">
							<div>
								发表时间：{{ item.publishedDate | dateFormat("YYYY-MM-DD") }}
							</div>
							<div style="margin-left: 16px;">
								引用频次：<span style="color: #3463ea;">{{
									item.citedCount || 0
								}}</span>
							</div>
						</div>
						<div class="entry">
							<div style="width: 7%;">摘要：</div>
							<div class="textOmitted" style="width: 93%;">
								{{ item.abstract }}
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="pagination">
				<el-pagination
					id="pagination"
					:current-page="pager.index"
					:page-sizes="[10, 25, 50]"
					:page-size="pager.size"
					layout="prev, pager, next, jumper, sizes"
					@current-change="query"
					@size-change="sizeChange"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { ApiClient, UserCenterApi } from "../../../../api"

export default {
	data() {
		return {
			api: new UserCenterApi(ApiClient.instance),
			records: [],
			total: 0,
			pager: {
				index: 1,
				size: 10
			}
		}
	},
	mounted() {
		this.query()
	},
	methods: {
		query() {
			this.api.apiUserCenterFavoritesGet(
				2,
				{
					index: this.pager.index,
					size: this.pager.size
				},
				(e, data, resp) => {
					data = resp.body
					if (data.success) {
						console.log(data)
						this.records = data.result.records
						this.total = data.result.total
						console.log(this.records)
						console.log(this.total)
					}
				}
			)
		},
		sizeChange(val) {
			this.pager.size = val
			this.query()
		}
	}
}
</script>

<style lang="less" scoped>
/*div文本过长显示...*/
.textOmitted {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
}
.item-list {
	width: 100%;
	a {
		text-decoration: none;
	}

	.item-container {
		width: 100%;
		display: inline-block;
		background-color: #ffffff;
		margin-top: 16px;

		.item {
			display: flex;
			margin: 16px 23px;

			.figure {
				width: 133px;
				height: 100%;
				border: 1px solid;
				margin: auto;
			}

			.location {
				position: relative;
				.c-font-size-16();
				line-height: 20px;
				flex-direction: row;
				text-align: left;
				width: 100%;
				padding-left: 1rem;

				.entry {
					display: flex;
					flex-direction: row;
					margin-right: 20px;
					margin-bottom: 12px;
					color: #555555;
					font-weight: 400;
				}

				.entry-title {
					font-size: 20px;
					color: #3463ea;
					margin-bottom: 20px;
				}

				.entry-cited {
					position: absolute;
					display: flex;
					top: 0rem;
					right: 0rem;
					color: #3463ea;
				}
			}
		}
	}

	.pagination {
		display: flex;
		justify-content: center;
		margin: 10px auto;
	}
}
</style>
